module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-b0946b7be882fce0d4462b59bc15fd73.png";